<template>
	<section :class="{unfold: unfolded}">
		<div class="wrapper">
			<header>
				<div class="heading" @click="unfolded = !unfolded">
					<img src="../assets/images/ico-heart-compounded.svg" class="ico-heart" />
					<h3>What is the<br> Wall of giving?</h3>
				</div>
				<p>The Wall of Giving is where you can send a public message and virtual gift to anyone at the Prince of Wales Hospital - a sick patient, the hard-working doctors and staff members or to a colleague to brighten their day.</p>
				<p>Send birthday wishes, messages of support, gratitude for a job well done or to congratulate someone on the birth of a baby. Whatever the message, it’s sure to make a difference to someone’s day!</p>
			</header>

			<main>
				<h3>How to Take Part</h3>
				<the-info-item type="message">
					<h4 slot="title"><span>1.</span> Message</h4>
					<p>Write your message, addressing the person you want to receive it.</p>
				</the-info-item>

				<the-info-item type="gift">
					<h4 slot=title><span>2.</span> Gift</h4>
					<p>Choose a virtual gift to go with your message. All proceeds will be donated to the Prince of Wales Hospital Foundation.</p>
				</the-info-item>

				<the-info-item type="share">
					<h4 slot=title><span>3.</span> Share</h4>
					<p>Share your message on Facebook to encourage others to take part too.</p>
				</the-info-item>

				<p>Your message will appear on the ‘Wall of Giving’ at the Prince of Wales Hospital once it has been approved. Entering the recipient’s email address will also share the message directly with them.</p>
			</main>

		</div>
	</section>
</template>

<script>
import TheInfoItem from './TheInfoItem';

export default {
	components: { TheInfoItem },
	data () {
		return {
			unfolded: false,
		};
	},
};
</script>

<style lang=less scoped>
	@import (reference) '../assets/less/default.less';

	section { width: 50%; background-color: @green; color: white; text-align: right; }
	.wrapper { display: inline-block; max-width: 350px; margin: 70px 118px 3vw 0; text-align: center; }
	.ico-heart { .size(74px, 74px); }

	h3 { margin: 1ex auto; font-size: 32/16rem; text-transform: uppercase; }
	main h3 { margin-bottom: 2rem; text-align: left; }
	p { font-size: 1rem; text-align: left; }

	header { margin-bottom: 2rem; padding-bottom: 2em; border-bottom: 2px dashed @yellow;
		p:last-of-type { margin-bottom: 0; }
	}

	@media @mobile, @tablet {
		section { width: 100%; max-height: 90px; overflow: hidden; background-image: linear-gradient(180deg, #92C97D 0%, @green 100%); transition: all 0.6s ease;
			.heading { height: 90px; }
		}
		section.unfold { max-height: 3000px; }
		section.unfold .heading:after { transform: rotate(135deg); }
		.wrapper { margin: 0 5vw 5vw; max-width: unset; text-align: left; }

		h3 { font-size: 20/16rem; }
		main h3 { text-align: center; }

		header {
			.heading { display: flex; justify-content: space-between; align-items: center;
				&:after { .pseudo(); .size(20px); border: 2px solid @yellow; border-width: 2px 2px 0 0; transform: rotate(45deg); transition: all 0.6s ease; }
			}
			h3 { display: inline-block; max-width: 180px; text-align: center; }
			.ico-heart { display: inline-block; width: 50px; }
		}
	}

	@media @tablet {
		header {
			h3 { max-width: unset; width: 100%; font-size: 2rem;
				br { display: none; }
			}
		}
		main h3 { font-size: 2rem; }
	}
</style>



// WEBPACK FOOTER //
// src/components/TheInfo.vue